'use strict';

import React from 'react';
import Post  from './PostComponent';
import Pager from './PagerComponent';
import Loading from './LoadingComponent';
import $ from 'jquery';

let config = require('config');

require('styles/Top.less');

class TopComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { actions, data, params } = this.props;
    var num = 1
    if (params.num) {
      num = parseInt(params.num)
    }
    actions.setCurrent(num)

    if (config.default.THEME == "B") {
      actions.indexOpen(0)
    } else {
      actions.getShowPosts(num)
    }
  }
  componentDidUpdate() {
    const { actions, data, params } = this.props;
    if (params.num) {
      var num = parseInt(params.num)
      if (num != data.currentShowPage) {
        actions.setCurrent(num)
        actions.getShowPosts(num)
        $(window).scrollTop(0)
      }
    } else {
      if (data.currentShowPage != 1) {
        actions.setCurrent(1)
        actions.getShowPosts(1)
        $(window).scrollTop(0)
      }
    }
  }
  render() {
    const { data } = this.props;
    if (data.showPosts == null || data.categories == null) {
      return (<Loading cl={"single"} />)
    }
    return (
      <div className='top'>
        <div className="posts">
          { data.showPosts ?
              data.showPosts.map(function(post, i){
                  return (
                    <Post post={post} cat={data.categories} type='list' key={i} />
                  )
                }
              )
          : null }
        </div>
        <Pager type="top" totalpage={data.totalShowPage} current={data.currentShowPage} num={data.currentShowPage} />
      </div>
    );
  }
}

TopComponent.displayName = 'TopComponent';

// Uncomment properties you need
// TopComponent.propTypes = {};
// TopComponent.defaultProps = {};

export default TopComponent;



// WEBPACK FOOTER //
// ./src/components/TopComponent.js